module.exports = __webpack_public_path__ + "img/hm-bed.2a610d0b.png";